<template>
  <div style="margin-bottom: 5px;"><!--page-break-after:always 20230621-->
    <div class="approve_content">
      <div
        :class="[!myReadType ? 'form-container' : 'form-container-not']"
        ref="formContainer"
        :style="status_style"
      >
        <span>审批内容</span>
        <div
          class="urgent_state_div"
          v-if="urgentStateConf.conf && urgentStateConf.conf.length > 0"
        >
          <span>紧急状态:</span>
          <span v-if="urgentStateConf.right == 'w'">
            <label
              :style="'color:' + c.color"
              class="radio-inline"
              v-for="c in urgentStateConf.conf"
              :key="c.state"
            >
              <input
                :value="c.state"
                type="radio"
                v-model="urgentStateConf.value"
              />
              {{ c.name }}
            </label>
          </span>
          <span v-if="urgentStateConf.right != 'w'">
            <span
              v-show="c.state == urgentStateConf.value"
              :style="'color:' + c.color"
              v-for="c in urgentStateConf.conf"
              :key="c.state"
              >{{ c.name }}</span
            >
          </span>
        </div>
        <div
          class="urgent_state_div"
          v-if="formHelpFile && formHelpFile.length > 0"
        >
          <el-button
            class="help"
            icon="el-icon-question"
            type="text"
            @click="previewHelpFile"
            >帮助</el-button
          >
        </div>
        <div class="urgent_state_div" v-if="workOrderNo">
          <span>工单号：{{workOrderNo}}</span><br/>
          <span v-show="isPrint">表单打印次数: {{printCount}}</span>
        </div>
      </div>
      <div class="form-content">
        <form v-if="html && formType == 'INNER'" data-vv-scope="custom-form">
          <online-form
            class="custom-form"
            :html="html"
            :data="data"
            :permission="permission"
            :isView="isView"
            :workOrderNo="workOrderNo"
          />
        </form>
        <div v-if="htmlSrc && formType == 'FRAME'" class="tab-container ">
          <iframe
            v-iframetrigger
            id="frmFrame"
            name="frmFrame"
            style="height:100%;width:100%;border:0px"
            :src="htmlSrc"
          ></iframe>
          {{ htmlSrc }}
        </div>
      </div>
      <!-- 预览文件-->
      <FilePreview ref="filePreview" />
    </div>
  </div>
</template>
<script>
import OnlineForm from "@/components/flow/OnlineForm.vue";
import form from "@/api/formContent.js";
import { Message } from "element-ui";
import { Loading } from "element-ui";
import FilePreview from "@/components/common/FilePreview.vue";
import req from "@/request.js";
export default {
  name: "formContent",
  props: [
    "instId",
    "taskId",
    "defId",
    "proInstId",
    "type",
    "readId",
    "readDoneId",
    "myReadType",
    "leaderId",
    "formLoading",
    "task_state",
    "tasks",
    "copeInstId",
    "opinionFieldList", //所有任务节点的绑定的意见回填,
    "workOrderNo" //工单号
  ],
  data() {
    return {
      buttons: [],
      status_style: "",
      dataInstId: "",
      html: null,
      data: null,
      permission: null,
      isView: true,
      formType: "INNER",
      htmlSrc: null,
      urgentStateConf: {},
      formHelpFile: "",
      src: "",
      files: [],
      fileId: "",
      fileTree: "",
      formData: "",
      topDivHeight: "99px", //空div的高度 用于撑开页面下的div内容
      formKey: "", //表单key
      printCount: 0,
      isPrint: false // 判断是否处于打印状态
    };
  },
  watch: {
    tasks: function(newVal, oldVal) {
      if (newVal) {
        this.init();
      }
    },
    urgentStateValue: function(newVal, oldVal) {
      if (window.urgentStateValue) {
        window.urgentStateValue.new = newVal;
      }
    }
  },
  created() {
    window.jQuery("#app").find("#hymenu").css("width","0px;");
    window.jQuery("#app").find("#hycontent").css({"width":"100%;"});
    this.init();
    if (
      location.pathname
        .split("/")
        .slice(4)
        .join() === "isRelatedFlow"
    ) {
      this.topDivHeight = "30px";
    }
  },
  methods: {
    /**
     * 修改样式
     * @param divheight  最上面div的高度
     */
    updateStyle(divheight) {
      this.topDivHeight = divheight;
    },
    previewHelpFile() {
      let obj = {};
      obj.id = this.formHelpFile[0].id;
      obj.name = this.formHelpFile[0].name;
      obj.size = this.formHelpFile[0].size;
      this.$refs.filePreview.preview(obj);
    },
    hiddenContent() {
      this.topDivHeight = "10px";
      this.$refs.formContainer.className = "form-container-not";
    },
    init() {
      if (this.task_state == "FOLLOW") {
        this.status_style = "padding-top:0px !important;";
      }
      var $ = require("jquery");
      let _me = this;
      let handlerJs = function(rep) {
        const currentUser = _me.$store.state.login.currentUser;

        let data = _me.data;
        if (rep && rep.diyJs) {
          eval(rep.diyJs);
        }
      };

      let handler = function(rep) {
        if (rep.buttons) {
          _me.buttons = rep.buttons;
        }
        if (_me.myReadType == "agent") {
          Message.warning("此流程已被委托,没有审批权");
        }
        if (!rep) {
          return;
        }
        if (JSON.stringify(rep) == "{}") {
          Message.error("此流程还没有设置全局表单,请先设置全局表单!");
          return;
        }
        if (rep.resultMsg == "formEmpty" || rep.result == "formEmpty") {
          Message.error("此流程还没有设置表单,请先设置表单!");
          return;
        }
        _me.getPrintCount();
        _me.formKey = rep.form.formKey;
        //_me.formId=rep.form.formId;
        if (rep.form && rep.form.type == "FRAME") {
          _me.htmlSrc = rep.form.formValue;
          _me.formType = rep.form.type;
          //表单加载完成发布事件 审批按钮才可以点击
          _me.$root.$emit("formLoading", false);
        } else {
          form.preview(rep.form.formId, handlerJs);
          if (_me.formData) {
            _me.data = JSON.parse(Base64.decode(_me.formData));
          } else {
            _me.data = rep.data;
          }

          if (rep.permission) {
            const permissionObj = JSON.parse(rep.permission);
            let commonRight = "";
            //如果是管理端进入，则将页面字段的权限修改为可编辑
            if (_me.type == "manage") {
              commonRight = "w";
              //如果是查看实例，也是获取发起流程的表单和权限。只不过所有可见的权限要变成编辑
            } else if (
              "request" == _me.type ||
              _me.myReadType == "myRequest" ||
              _me.myReadType == "delegate" ||
              _me.myReadType == "myRead" ||
              _me.readDoneId ||
              _me.type == "read"
            ) {
              commonRight = "r";
            }
            if (permissionObj.fields && commonRight) {
              for (var key in permissionObj.fields) {
                const bodef = permissionObj.fields[key];
                if (bodef) {
                  for (var fname in bodef) {
                    if (
                      commonRight == "w" ||
                      (commonRight == "r" && bodef[fname] != "n")
                    ) {
                      bodef[fname] = commonRight;
                    }
                  }
                }
                permissionObj.fields[key] = bodef;
              }
            }
            if (permissionObj.table && commonRight) {
              for (var key in permissionObj.table) {
                const table = permissionObj.table[key];
                if (table) {
                  if (commonRight == "w") {
                    table["hidden"] = false;
                    table["add"] = true;
                    table["del"] = true;
                  } else if (commonRight == "r") {
                    table["add"] = false;
                    table["del"] = false;
                    table["required"] = false;
                  }
                }
                permissionObj.table[key] = table;
              }
            }
            _me.permission = permissionObj;
            if (
              "request" == _me.type ||
              _me.myReadType == "myRequest" ||
              _me.myReadType == "delegate" ||
              _me.myReadType == "myRead" ||
              _me.readDoneId ||
              _me.type == "read"
            ) {
              _me.opinionFieldList.forEach(opinionField => {
                const field = opinionField.split(".");
                let keyNames = "";
                let mark = true;
                if (!_me.data[field[1]][field[2]]) {
                  for (var fieldKey in _me.permission.fields) {
                    for (var tableKey in _me.permission.table) {
                      if (fieldKey == tableKey) {
                        mark = false;
                        break;
                      }
                    }
                    if (mark) {
                      keyNames = fieldKey + "," + keyNames;
                    }
                  }
                  if (keyNames) {
                    const keyName = keyNames.split(",");
                    keyName.forEach(name => {
                      if (name) {
                        _me.permission.fields[name][field[2]] = "r";
                      }
                    });
                  }
                }
              });
            }
          }
          _me.html = rep.form.formHtml;
          if (rep.form.helpFile) {
            _me.formHelpFile = JSON.parse(rep.form.helpFile);
          }
          if (_me.html.split('ref="next_step_check_').length > 1) {
            _me.$root.$emit("startFlowBtnChange", false);
          }
          //表单加载完成发布事件 审批按钮才可以点击
          _me.$root.$emit("formLoading", false);
        }
      };
      this.$store
        .dispatch("storeProcess/getUrgentStateConf", {
          defId: this.defId,
          instId: this.instId,
          taskId: this.taskId
        })
        .then(data => {
          if (data.conf) {
            try {
              data.conf = JSON.parse(data.conf);
            } catch (error) {
              data.conf = eval("(" + data.conf + ")");
            }
            window.urgentStateValue = { old: data.value };
            if (!data.value) {
              for (let index = 0, c; (c = data.conf[index++]); ) {
                if (c.default) {
                  data.value = c.state;
                  break;
                }
              }
            }
            _me.urgentStateConf = data;
          }
        });
      if (this.taskId && (this.tasks && JSON.stringify(this.tasks) != "{}")) {
        if (
          !this.tasks.bpmTask &&
          !this.tasks.state &&
          (this.tasks.message == "流程当前节点任务您已在其他页面处理，点击确认后将关闭当前页面。" || this.tasks.message == " 流程当前节点任务您已在其他页面处理，点击确认后将关闭当前页面。")
        ) {
          $("body").html("");
          window.app.$alert("流程当前节点任务您已在其他页面处理，当前页面将在两秒后关闭。", '提示');
          setTimeout(function(){
            window.close();
          },2000)
          //_me.$router.push("/v-flow/v-todo");
          //return;
        }
        if (this.tasks.bpmTask.bpmnInstId) {
          form.taskDetail(
            { taskId: this.taskId, leaderId: this.leaderId },
            handler
          );
        } else {
          form.getInstFormAndBO(this.tasks.bpmTask.procInstId, handler);
        }
      } else if (this.instId) {
        this.isView = false;
        if ("request" == this.type) {
          //form.getInstFormAndBO({instId:this.instId,getStartForm:true}, handler);
          //查看我发起的，也使用发起流程的表单
          form.getFormAndBO({ proInstId: this.instId }, handler);
        } else if ("read" == this.type || this.myReadType) {
          const this_ = this;
          if (this.readId) {
            //知会待办
            //根据待办知会任务主键ID获取任务ID
            this.$store
              .dispatch("storeProcess/getBpmTaskNoticeById", this_.readId)
              .then(row => {
                if (row.taskId) {
                  //根据任务Id获取审批历史数据（只有一条）
                  this.$store
                    .dispatch("storeProcess/getTaskKeyByTaskId", row.taskId)
                    .then(res => {
                      //客户要求传阅和已阅数据显示最新的
                      // if (res.formData) {
                      //   this_.formData = res.formData;
                      // }
                      //20240913曾琦注释
                      //let isIncludData = res.formData ? false : true;
                      let isIncludData = true;
                      let taskKey = '';
                      if (res!=null && res.formData) {
                        isIncludData = false;
                        taskKey = res.taskKey;
                      }
                      form.getInstFormAndBO(
                        {
                          instId: this_.instId,
                          nodeId: taskKey,
                          includData: isIncludData
                        },
                        handler
                      );
                    });
                } else if (row.nodeId) {
                  let data = { nodeId: row.nodeId, instId: this_.instId };
                  //根据任务节点ID和流程实例ID获取审批历史数据（只有一条）
                  this.$store
                    .dispatch("storeProcess/getTaskKeyByNodeId", data)
                    .then(res => {
                      // if (res.formData) {
                      //   this_.formData = res.formData;
                      // }
                      //20240913曾琦注释
                      //let isIncludData = res.formData ? false : true;
                      let isIncludData = true;
                      let taskKey = '';
                      if (res!=null && res.formData) {
                        isIncludData = false;
                        taskKey = res.taskKey;
                      }
                      form.getInstFormAndBO(
                        {
                          instId: this_.instId,
                          nodeId: taskKey,
                          includData: isIncludData
                        },
                        handler
                      );
                    });
                } else {
                  //查看我发起的，也使用发起流程的表单
                  form.getFormAndBO({ proInstId: this.instId }, handler);
                  // form.getInstFormAndBO(this_.instId, handler);
                }
              });
          } else if (this.readDoneId) {
            //知会已办
            //根据已办知会任务主键ID获取任务ID
            this.$store
              .dispatch(
                "storeProcess/getBpmTaskNoticeDoneById",
                this_.readDoneId
              )
              .then(row => {
                if (row.taskId) {
                  //根据任务Id获取审批历史数据（只有一条）
                  this.$store
                    .dispatch("storeProcess/getTaskKeyByTaskId", row.taskId)
                    .then(res => {
                      // if (res.formData) {
                      //   this_.formData = res.formData;
                      // }
                      //20240913曾琦注释
                      //let isIncludData = res.formData ? false : true;
                      let isIncludData = true;
                      let taskKey = '';
                      if (res!=null && res.formData) {
                        isIncludData = false;
                        taskKey = res.taskKey;
                      }
                      form.getInstFormAndBO(
                        {
                          instId: this_.instId,
                          nodeId: taskKey,
                          includData: isIncludData
                        },
                        handler
                      );
                    });
                } else if (row.taskKey) {
                  let data = { nodeId: row.taskKey, instId: this_.instId };
                  //根据任务节点ID和流程实例ID获取审批历史数据（只有一条）
                  this.$store
                    .dispatch("storeProcess/getTaskKeyByNodeId", data)
                    .then(res => {
                      // if (res.formData) {
                      //   this_.formData = res.formData;
                      // }
                      //20240913曾琦注释
                      //let isIncludData = res.formData ? false : true;
                      let isIncludData = true;
                      let taskKey = '';
                      if (res!=null && res.formData) {
                        isIncludData = false;
                        taskKey = res.taskKey;
                      }
                      form.getInstFormAndBO(
                        {
                          instId: this_.instId,
                          nodeId: taskKey,
                          includData: isIncludData
                        },
                        handler
                      );
                    });
                } else {
                  //查看我发起的，也使用发起流程的表单
                  form.getFormAndBO({ proInstId: this.instId }, handler);
                  // form.getInstFormAndBO(this_.instId, handler);
                }
              });
          } else {
            //查看我发起的，也使用发起流程的表单
            form.getFormAndBO({ proInstId: this.instId }, handler);
            // form.getInstFormAndBO(this.instId, handler);
          }
        } else {
          //查看我发起的，也使用发起流程的表单
          form.getFormAndBO({ proInstId: this.instId }, handler);
          // form.getInstFormAndBO(this.instId, handler);
        }
      } else if (this.defId) {
        let data = {};
        if (this.proInstId != undefined) {
          data = { defId: this.defId, proInstId: this.proInstId };
        } else if (this.copeInstId) {
          data = { defId: this.defId, copeInstId: this.copeInstId };
        } else {
          data = { defId: this.defId };
        }
        form.getFormAndBO(data, handler);
      }
    },
    getPrintCount() {
      // 获取打印次数
      req
        .post(
          window.context.bpmRunTime +
            "/runtime/bpmPrintRecord/v1/getPrintCount/" +
            this.instId
        )
        .then(resp => {
          this.printCount = Number(resp.data.value) + 1;
        });
    }
  },
  computed: {
    urgentStateValue: function() {
      return this.urgentStateConf.value;
    }
  },
  components: { OnlineForm, FilePreview }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
.approve_content {
  padding: 4px 20px;
  background: #fff;
  width: 97%;
}
@media print {
  .approve_content {
    padding: 0px !important;
  }
}
/deep/.el-form-item {
  margin-bottom: 7px !important;
  margin-top: 7px !important;
  margin-right: 10px !important;
}
/deep/ .form-table {
  width: 100%;
  border-top: 1px solid #000000;
  border-left: 1px solid #000000;
}

/deep/ .form-table > thead > tr > th, /deep/ .form-table > tbody > tr > th {
  text-align: right;
  color: #666;
  font-weight: normal;
  font-size: 12px;
}

/deep/ .form-table > tbody > tr > th.group-th {
  text-align: left;
  background: #f9f9f9;
  font-weight: bold;
}

/deep/ .form-table > thead > tr.sub-table-header > th {
  text-align: center;
  background: #fafafa;
}

/deep/ .form-table > tbody > tr > th > span, /deep/ .form-table > thead > tr > th > span {
  color: #f00;
}

/deep/ .form-table > tbody > tr > th,
/deep/ .form-table > tbody > tr > td,
/deep/ .form-table > tfoot > tr > td,
/deep/ .form-table > thead > tr > th {
  border-right: 1px solid #000000;
  border-bottom: 1px solid #000000;
  padding: 10px;
  min-width: 0;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
}

/deep/ .form-table-noBorder {
  border-top: 0px solid #000000;
  border-left: 0px solid #000000;
}

/deep/ .form-table-noBorder > tbody > tr > th,
/deep/ .form-table-noBorder > tbody > tr > td,
/deep/ .form-table-noBorder > tfoot > tr > td,
/deep/ .form-table-noBorder > thead > tr > th {
  border-right: 0px solid #000000;
  border-bottom: 0px solid #000000;
}

/deep/ .form-table > tfoot > tr > td {
  padding: 5px 10px;
}

.form-container {
  border-bottom: 1px solid #000000;
  padding: 10px 0 4px 0;
}

.form-container-not {
  border-bottom: 1px solid #000000;
  margin: 20px 0px 0px 0px !important;
}

.form-container-not > span {
  border-left: 3px solid $--theme-color;
  font-weight: bold;
  font-size: 12px;
  padding-left: 10px;
  color: #000;
}

.form-container > span {
  border-left: 3px solid $--theme-color;
  font-weight: bold;
  font-size: 12px;
  padding-left: 10px;
  color: #000;
}

.form-content {
  padding: 1px 0;
  /deep/ .el-form-item__content {
    p {
      margin: 0;
    }
  }
}
/deep/ div[aria-invalid="true"] + small,
/deep/ small.error-message {
  display: block;
  margin-top: 8px;
  color: #f56c6c;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
}

.urgent_state_div {
  display: inline-block;
  float: right;
}

.urgent_state_div > span {
  font-size: 12px;
  color: #000;
  padding-right: 5px;
}

/deep/.el-radio__label {
  padding-left: 5px;
}

/deep/.el-radio__input.is-checked + .el-radio__label {
  color: none !important;
}

/deep/.text-fixed p {
  margin: 0;
  margin-bottom: -2px;
}
.tab-container {
  height: 600px;
}
/deep/ .el-tag.el-tag--info{
  color: #000;
}
/deep/ .el-col{//div子表布局 07-21@ZQ
border:1px solid #000;
box-sizing:border-box;
margin: 0 -1px -1px 0;
}
/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:before{
  display:none;
}
</style>
